import { DEFAULT_TEXT_STYLE, chartColorPalette } from '../ChartWidget.config';
import { extendSeriesData } from '../ChartWidget.helpers';
import { ChartDataSeries } from '../ChartWidget.types';

const DEFAULT_WIDTH = 503;
const DEFAULT_HEIGHT = 318;

const DEFAULT_FONT_FAMILY = 'Inter';
const DEFAULT_BORDER_WIDTH = 2;
const DEFAULT_BORDER_COLOR = '#FFF';

const DEFAULT_SCATTER_BUBBLE_CHART_DATA = {
  legend: {
    enabled: false,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  dataLabels: {
    inside: true,
    enabled: false,
    style: {
      ...DEFAULT_TEXT_STYLE,
      fontFamily: DEFAULT_FONT_FAMILY,
    },
  },
  seriesData: extendSeriesData([
    {
      name: 'Temperature',
      data: [53, 54, 56, 58, 60, 62, 63, 63, 64, 65, 65],
    },
    {
      name: 'Sales',
      data: [215, 125, 175, 185, 275, 425, 275, 332, 410, 478, 440],
    },
    {
      name: 'Revenue',
      data: [430, 312, 350, 462, 550, 850, 550, 830, 1025, 956, 880],
    },
    // TODO: Re-enable the sample: product type categories column when multi-series is implemented
    // {
    //   name: 'Product Type',
    //   data: [
    //     'Product B',
    //     'Product A',
    //     'Product A',
    //     'Product B',
    //     'Product A',
    //     'Product A',
    //     'Product B',
    //     'Product B',
    //     'Product B',
    //     'Product A',
    //     'Product A',
    //   ],
    // },
  ] as ChartDataSeries),
  seriesMeta: {
    colors: chartColorPalette,
  },
  xAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Temperature (fahrenheit)',
      style: {
        ...DEFAULT_TEXT_STYLE,
      },
    },
    style: {
      lineColor: '#000000',
      lineWidth: 1,
    },
    enableLine: true,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  yAxis: {
    gridLineWidth: 1,
    title: {
      text: 'Sales',
      style: {
        ...DEFAULT_TEXT_STYLE,
      },
    },
    style: {
      lineColor: '#000000',
      lineWidth: 1,
    },
    enableLine: true,
    labelStyle: {
      ...DEFAULT_TEXT_STYLE,
    },
  },
  grid: {
    style: {
      lineColor: '#DBDBDB',
    },
  },
  generalOptions: {
    innerSize: 0,
    borderWidth: DEFAULT_BORDER_WIDTH,
    borderColor: DEFAULT_BORDER_COLOR,
  },
  patterns: {
    enabled: false,
    list: [],
  },
};

export { DEFAULT_HEIGHT, DEFAULT_WIDTH, DEFAULT_BORDER_WIDTH, DEFAULT_BORDER_COLOR, DEFAULT_SCATTER_BUBBLE_CHART_DATA };
